import { render } from "./Cards.vue?vue&type=template&id=803730a2&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=ts"
export * from "./Cards.vue?vue&type=script&lang=ts"

import "./Cards.vue?vue&type=style&index=0&id=803730a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-803730a2"

export default script